<!--section about us-->
<section>
    <div class="container-fluid">
        <div class="row" style="height:420px;padding-top: 75px;">
            <div class="col-md-12" style="padding-left: 0px;">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3322.192320647353!2d-111.94442378531257!3d33.62625504750657!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b75ee96177727%3A0x28c1543c08c3d78e!2sSFI%20Compliance%2C%20Inc.!5e0!3m2!1sen!2sin!4v1593711486102!5m2!1sen!2sin"
                    width="{{windowwidth}}" height="419" frameborder="0" style="border:0;" allowfullscreen="true"
                    aria-hidden="false" tabindex="0"></iframe>
            </div>
        </div>
    </div>
</section>
<!-- end section -->

<!-- row 1 -->
<section style="background-color: #F2F3F5;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 pl-5" data-aos="fade-right" style="background-color: white;">
                <h4 style="padding-top:50px;"><strong class="theme_color">Arizona Office</strong></h4>
                <p><i class="fa fa-map-marker"></i>&nbsp;6424 E Greenway Pkwy. Suite #100, Scottsdale, AZ 85254</p>
                <p><i class="fa fa-phone-square"></i>&nbsp;602-325-1950</p>
                <!-- <p><i class="fa fa-hourglass"></i>&nbsp;&nbsp;Working hours 8:00AM - 4:30PM (Mountain Standard Time)</p> -->
                <p><i class="fa fa-envelope-o"></i>&nbsp;<a href="mailto:customerservice@sficompliance.com">
                        customerservice@sficompliance.com</a></p>

                <hr />

                <h4 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    SFI Compliance is a Proud Member of:
                </h4>

                <a href="https://www.azbuilders.org/" target="_blank"><img data-aos="zoom-in" data-aos-delay="100"
                        src="../../assets/images/ABA-logo.png" class="img-fluid" /></a><br />
                <p></p>
                <a href="https://www.hbaca.org/" target="_blank"><img data-aos="zoom-in" data-aos-delay="200"
                        src="../../assets/images/hbaca.PNG" class="img-fluid" /></a><br />

                <hr />

                <h4 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    Don’t miss the latest safety news!
                </h4>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="200">We share important OSHA safety news and
                    updates, useful safety information you can share with your team, and a list of our upcoming Texas
                    safety classes.</p>

                <a role="button" class="btn btn-danger" target="_blank"
                    href="https://visitor.r20.constantcontact.com/manage/optin?v=0017rDYctTjtbhpHTxBvvbPrdbMCpKVTALAHMl1Kd6ARZ3ut4m_I_5dAS0Ba0GRsYdPWr0EKA-U0cVqSVYFZa1fYGmfGSoS8l4SLImJWT82kDm-hifk4CfeVPlsp9Ga520POQFMK2VYN-6djPNOB0UEALfmi_NFJkfxzyPjSaPHQRAku9390UNYkqaEaq6R8TLf">SIGN
                    UP NOW!</a>
            </div>

            <div class="col-lg-8 pl-5" data-aos="fade-left">
                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100" style="padding-top:50px;">
                    Your Full-Service Arizona Jobsite Safety Company.
                </h3>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">Our full-service, bilingual safety
                    consulting firm now has a location in Scottsdale, Arizona! We provide safety consulting and services
                    to all of Arizona, including areas in and around Phoenix, Tucson, and Flagstaff. From the boardroom
                    to your Arizona job site, our safety team works with your team to keep everyone safe!</p>

                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    Arizona Workplace Safety Data and Reports.
                </h3>
                <span data-aos="fade-up" data-aos-delay="100">Keep your Arizona workforce safe - in 2019 there were 94
                    work-related fatalities in Arizona, or approximately one work-related fatality every 3.9 days. Every
                    year thousands of other people are also injured on the job or become ill from work-related
                    exposures.</span>

                <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="100">
                    <li><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;<a
                            href="https://www.bls.gov/news.release/pdf/cfoi.pdf" target="_blank">Bureau of Labor
                            Statistics Report</a></li>
                </ul><br />

                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    SFI specializes in:
                </h3>

                <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="100">
                    <li data-aos="fade-up" data-aos-delay="100"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;Multi-Family Residential (Apartments)
                    </li>
                    <li data-aos="fade-up" data-aos-delay="200"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;Home Building – Single Family and
                        Multi-Family</li>
                    <li data-aos="fade-up" data-aos-delay="300"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;Commercial Construction</li>
                    <li data-aos="fade-up" data-aos-delay="400"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;Heavy Highway Construction</li>
                    <li data-aos="fade-up" data-aos-delay="500"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;Bridge Construction</li>
                    <li data-aos="fade-up" data-aos-delay="600"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;Commercial Manufacturing</li>
                    <li data-aos="fade-up" data-aos-delay="700"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;General Industry</li>
                </ul><br />

                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    SFI Compliance –your jobsite safety partner in Arizona!
                </h3>

                <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="100">
                    <li data-aos="fade-up" data-aos-delay="100"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;Over 100 years of workplace safety and
                        risk management experience</li>
                    <li data-aos="fade-up" data-aos-delay="200"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;Industry recognition for excellence</li>
                    <li data-aos="fade-up" data-aos-delay="300"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;Extensive bilingual capabilities</li>
                    <li data-aos="fade-up" data-aos-delay="400"><i
                            class="fa fa-circle fontRed facirclesize"></i>&nbsp;Advanced certifications</li>
                </ul><br />

                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    Arizona Safety Programs.
                </h3>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    All of our Arizona job site safety programs meet ADOSH standards and requirements.
                    SFI Compliance follows OSHA-recommended practices when writing or revising a program.
                    Know that you are providing a safe environment for everyone - our ADOSH written safety programs in
                    both English and Spanish promote a company’s work safety rules and employee training guidelines.
                </p>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    We know safety is good for your Arizona business, that’s why for over 30 years we have kept
                    companies ADOSH-Compliant.
                </p>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    A well-managed workplace safety program provides real protection for your workers and your business
                    - find out more about our
                    <a href="/safetyprogram">Safety Programs</a>.
                </p>

                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    Arizona Onsite Safety Training.
                </h3>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    Our safety training empowers your workforce to work smart, work safe, and return home safely. An
                    effective ADOSH training program can result in fewer injuries and illnesses, better morale and lower
                    workers’ compensation insurance premiums.
                </p>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    SFI Compliance has over 100 years of combined safety training experience and provides training for
                    all safety requirements.
                    Our experienced Arizona safety instructors are approved by the US Department of Labor to provide
                    training.
                    They will travel to your location and provide on-site safety training for your company.
                </p>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    Our ADOSH safety training programs are custom-tailored to your specific needs - find out more about
                    our
                    <a href="/safetytraining"> Safety Training</a>.
                </p>


                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    Arizona Jobsite Safety Inspections.
                </h3>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    Maintain ADOSH Compliance and avoid hefty fines and injured workers with our safety inspections.
                    Don’t wait for an unexpected ADOSH job site inspection! An integral part of a safety program, our
                    job site safety inspections help us to evaluate your safety program.
                </p>
                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">Our Arizona safety inspection team will do a
                    thorough inspection of your job site to identify safety hazards and provide the necessary
                    recommendations to correct them.</p>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    We know what ADOSH looks for! Keep your Arizona company ADOSH-Compliant – see our complete list of
                    workplace <a href="/safetyinspection"> Safety Inspection options</a>.
                </p>
            </div>
        </div>
    </div>
</section>
<!-- end section-->